import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "editor-toolbar-clip",
  "use": "editor-toolbar-clip-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"editor-toolbar-clip\">\n    <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M14 5.81v8c0 2.316-1.79 4.19-4 4.19s-4-1.874-4-4.19V5.048C6 3.364 7.302 2 8.91 2c1.606 0 2.908 1.364 2.908 3.048v8c0 1.051-.814 1.904-1.818 1.904s-1.818-.853-1.818-1.904V5.81h.727v7.238c0 .63.489 1.142 1.091 1.142s1.09-.511 1.09-1.142v-8c0-1.263-.976-2.286-2.18-2.286-1.206 0-2.183 1.023-2.183 2.286v8.762c0 1.893 1.466 3.428 3.273 3.428 1.807 0 3.273-1.535 3.273-3.428v-8H14z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol